module.exports = __webpack_public_path__ + "static/media/onboarding-logo.80ca7596.svg";